import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE, CHECKBOX_LOADER, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useDispatch } from "react-redux";
import "react-quill/dist/quill.snow.css";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { memberCarTrackingLevel } from "../../../../constant";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";

export const AdminSupportSettingsAccordion = ({ memberAntiTamper,
    setMemberAntiTamper,
    memberTracking,
    setMemberTracking    
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const { AdminandSupportLoader } = useHookstate(CHECKBOX_LOADER);

     const { memberCarTracking } = useHookstate(MAP_GLOBAL_STATES);

    const handleMemberAntiTamperChange = (e) => {
        setMemberAntiTamper(e.target.value);
        AdminandSupportLoader.set(true);
        dispatch(COMMON_SERVICES.putAllowAntiTamperSelectionServices(e.target.value, siteId.get()))
            .then(() => { AdminandSupportLoader.set(false) });
    }

    const handleMemberCarTrackingChange = (e) => {
        const selectedEnumValue = e.target.value;
        setMemberTracking(selectedEnumValue);

        const selectedStringValue = Object.keys(memberCarTrackingLevel)
            .find(key => memberCarTrackingLevel[key] === selectedEnumValue);

        memberCarTracking.set(selectedStringValue);
        AdminandSupportLoader.set(true);
        dispatch(COMMON_SERVICES.putUpdateMemberCarTrackingLevelServices(e.target.value, siteId.get()))
            .then(() => { AdminandSupportLoader.set(false) });
    }

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ background: "var(--admin-tab-bg)" }}
                >
                    <Heading>
                        <h3>{t("Admin_and_Support_Settings")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        {AdminandSupportLoader.get() && (
                            <CenteredLoader className="innerSectionLoader">
                                <Loader />
                            </CenteredLoader>
                        )}
                        <CheckBoxWrapper className="mt-20">
                            <CustomizedCheckbox
                                lockdownText="powermanagement"
                                label={t("Power_management")}
                                name="Power Management"
                                width={15}
                                height={15}
                            />
                        </CheckBoxWrapper>
                        <div className="select-wrapper">
                            <p className="label">{t("Member_Anti_Tamper")}</p>
                            <FormControl size="small">
                                <Select
                                    value={memberAntiTamper}
                                    name="Member Anti Tamper"
                                    onChange={(e) => {
                                        handleMemberAntiTamperChange(e)
                                    }}
                                    inputProps={{ "aria-label": "Without label" }}
                                >
                                    <MenuItem value={memberCarTrackingLevel.Never}>{t("Never")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.Always}>{t("Always")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.InsideGeoFence}>{t("Within_Geofence")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.OnCourseOrPlayingGolf}>{t("OnCourse_or_PlayingGolf")}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="select-wrapper">
                            <p className="label">{t("Member_Car_Tracking")}</p>
                            <FormControl size="small">
                                <Select
                                    value={memberTracking}
                                    name="CarSetting"
                                    onChange={(e) => {
                                        handleMemberCarTrackingChange(e)
                                    }}
                                    inputProps={{ "aria-label": "Without label" }}
                                >
                                    <MenuItem value={memberCarTrackingLevel.Never}>{t("Never")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.Always}>{t("Always")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.InsideGeoFence}>{t("Within_Geofence")}</MenuItem>
                                    <MenuItem value={memberCarTrackingLevel.OnCourseOrPlayingGolf}>{t("OnCourse_or_PlayingGolf")}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};